import { useState, useEffect } from "react";
import HeaderSingleWall from "./HeaderSingleWall";

import { firestore } from "../firebase";
import { collectIdsAndDocs } from "../utils";
// import { Container } from "rsuite";
import {
  useParams,
  matchPath,
  useHistory,
  Link,
  useLocation,
} from "react-router-dom";
// import { id } from "./Site";

import Loader from "./Loader";

import { Container, CssBaseline, Card, Typography } from "@mui/material";
import {
  doc,
  setDoc,
  getDoc,
  collection,
  onSnapshot,
} from "firebase/firestore";
import { snapshotViewportBox } from "framer-motion";
import { WallpaperSharp } from "@mui/icons-material";

function PageWallSingle() {
  // const { handle } = useParams();
  const location = useLocation();
  const { siteId, formData, createdAt, siteStreet, siteNumber } =
    location.state;

  // const [wall, setWall] = useState([]);
  const [wall, setWall] = useState("");

  // const { siteid } = id();
  const { id } = useParams();

  const history = useHistory();

  // const match = matchPath(history.location.pathname, {
  //   // You can share this string as a constant if you want
  //   path: "/sites/:id",
  // });

  // let siteId;

  // // match can be null
  // if (match && match.params.id) {
  //   siteId = match.params.id;
  // }

  const wallRef = firestore.doc(`sites/${siteId}/walls/${id}`);

  let unsubscribeFromWall = null;

  useEffect(() => {
    unsubscribeFromWall = wallRef.onSnapshot((snapshot) => {
      const wall = collectIdsAndDocs(snapshot);
      setWall(wall);
    });

    return () => {
      unsubscribeFromWall();
    };
  }, []);

  // useEffect(() => {
  //   unsubscribeFromWall = wallRef.onSnapshot((snapshot) => {
  //     const wall = collectIdsAndDocs(snapshot);
  //     setWall(wall);
  //   });
  //   return () => {
  //     unsubscribeFromWall();
  //   };
  // });

  // const docRef = doc(firestore, "sites");

  // useEffect(() => {
  //   onSnapshot(
  //     collection(firestore, "sites", "mdfAar5ZWmIbVJ9sdOfu", "walls"),
  //     (snapshot) =>
  //       setWalls(snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
  //   );
  // });

  // useEffect(
  //   (formData) => {
  //     const unsubscribeFromWall = onSnapshot(docRef, (doc) => {
  //       setDoc(doc);
  //     });
  //     return () => unsubscribeFromWall();
  //   },
  //   [formData]
  // );

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  {
    return (
      <Container size="sm">
        <CssBaseline />

        {loading ? (
          <Loader />
        ) : (
          <HeaderSingleWall
            {...wall}
            // {...site}
            formData={formData}
            siteId={siteId}
            createdAt={createdAt}
            siteStreet={siteStreet}
            siteNumber={siteNumber}
          />
        )}
        {/* <Typography>{siteStreet}</Typography> */}

        {/* <Typography>{wall.id}</Typography> */}

        {/* {loading ? <Loader /> : <HeaderSingleWall {...wall} />} */}

        {/* <Typography>yo</Typography>*/}
        {/* <Typography>{wall.noteTest}</Typography> */}
        {/* <Typography>{wall.testMap.lol}</Typography> */}
        {/* <Typography>{wall.createdAt}</Typography> */}
        {/* <Typography>{wall.user.email}</Typography> */}
        {/* <Typography>{wall.formData.registrationPeriod}</Typography> */}
        {/* <Typography>{wall.id}</Typography>
        <Typography>{wall.createdAt}</Typography> */}
      </Container>
    );
  }
}

export default PageWallSingle;
